import React from "react";
import { Box } from "Components/Base/Layout/Box";
import { Typography } from "Components/Base/DataDisplay/Typography";
import BaseGrid from "Components/Fragment/BaseGrid";
import ActivityDescription from "Components/Module/LearningActivityItem/Description";
import { CLOCK } from "Components/Icons";
import { formatDuration } from "Common/utils/durationUtils";
import { isOnlineLearningActivityType } from "../../constants";
import { STYLE_CARD_HEADING } from "../../styles";

const CourseCardContent = ({ learningActivity, languageContext, listView }) => {
  const { description, shortDescription, duration, type } = learningActivity;
  const withDuration = duration && (duration.hours > 0 || duration.minutes > 0);
  const activityDescription = isOnlineLearningActivityType(type)
    ? shortDescription || description
    : description;

  return (
    <>
      <BaseGrid childWidth="auto">
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h4" sx={STYLE_CARD_HEADING}>
            {languageContext(
              isOnlineLearningActivityType(type) ? "onlinecourse" : type,
            )}
          </Typography>
          {withDuration && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <CLOCK fontSize="small" sx={{ mx: 1 }} />
              {formatDuration(duration)}
            </Box>
          )}
        </Box>
      </BaseGrid>

      <ActivityDescription
        description={activityDescription}
        maxLength={listView ? 10000 : 100}
      />
    </>
  );
};

export default CourseCardContent;
